import Button from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';

interface ButtonLinkProps {
    to?: string;
    text: string;
    variant?: 'contained' | 'outlined';
    icon?: React.ReactNode;
    fullWidth?: boolean;
    onClick?: (event: React.MouseEvent) => void;
}

export const ButtonLink: React.FC<ButtonLinkProps> = ({
    to = '',
    text,
    variant = 'contained',
    icon,
    fullWidth = true,
    onClick,
}) => (
    <Button
        fullWidth={fullWidth}
        to={to}
        component={Link}
        variant={variant}
        size="large"
        color="primary"
        startIcon={icon}
        onClick={onClick}
    >
        {text}
    </Button>
);
